'use client';

import useSWR from 'swr';
import { classificationApi } from '@/lib/api';
import type { StreamCandidatesResponse } from '@/types/onboarding';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

/**
 * The classification engine's read surface (VER-366): ranked streams worth asking
 * about plus the three-class totals. Candidates are recomputed server-side, so a
 * confirmed stream drops out on revalidation — consumers that keep answered cards
 * on screen must snapshot the list themselves.
 */
export function useStreamCandidates() {
  const authedFetch = useAuthedFetcher();

  return useSWR<StreamCandidatesResponse>(
    ['stream-candidates'],
    () => authedFetch((token) => classificationApi.getStreamCandidates(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
